// extracted by mini-css-extract-plugin
export default {"productGallery":"kN-z","inQuickShop":"lN-z"};